// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import theme from '../assets/theme';
import { AuthContext, useAuthContext } from '../auth/AuthContext';
import { isUserLoggedIn } from '../auth/utils/utils';
import { StateContext } from '../state/StateContext';
import { getCountiesFromStorage } from '../state/utils';
import CreateMembership from '../views/CreateMembership';
import Login from '../views/Login';

function RequireAuth({ children }: any) {
  const authenticated = useAuthContext();

  return authenticated.isAuthenticated === true ? (
    children
  ) : (
    <Navigate to="/login" replace />
  );
}


export function App() {
  const [authState, setAuthState] = useState({
    isAuthenticated: isUserLoggedIn(),
  });

  const [state, setState] = useState({
    counties: getCountiesFromStorage(),
  });

  return (
    <ThemeProvider theme={theme}>
      <AuthContext.Provider value={{ ...authState, setAuthState }}>
        <StateContext.Provider value={{ ...state, setState }}>
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <RequireAuth>
                    <CreateMembership />
                  </RequireAuth>
                }
              />
              <Route
                path="/login"
                element={
                  !authState.isAuthenticated ? (
                    <Login />
                  ) : (
                    <Navigate to="/create-membership" replace />
                  )
                }
              />
              <Route
                path="/create-membership"
                element={
                  <RequireAuth>
                    <CreateMembership />
                  </RequireAuth>
                }
              />
              <Route
                path="*"
                element={
                  <Navigate to="/" replace />
                }
              />
            </Routes>
          </BrowserRouter>
        </StateContext.Provider>
      </AuthContext.Provider>
    </ThemeProvider>
  );
}

export default App;
